import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initObservability } from "./lib/observability";

// SW registration intentionally disabled while we diagnose a blank-screen
// regression. Once the page loads cleanly, re-enable via:
//   import { registerServiceWorker } from "./lib/sw-register";
//   registerServiceWorker();

void initObservability();

// Defensive: if a previous SW was registered and is now intercepting
// requests with stale responses, unregister it on startup.
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(regs => regs.forEach(r => r.unregister()))
    .catch(() => undefined);
}

if (!window.location.hash) {
  window.location.hash = "#/";
}

createRoot(document.getElementById("root")!).render(<App />);
